import styles from './ProtocolHandler.module.css';

import protocolIcon from '../../../../assets/svg/protocol-01.svg';
import attentionIcon from '../../../../assets/svg/attention-01.svg';

import AddResourceButton from '../../SchemeButtons/AddResourceButton';
import ProtocolSelectMenu from '../../SchemeMenus/ProtocolSelectMenu';
import React from 'react';
import useContextMenu from '../../../../hooks/useContextMenu';
import useOutsideClick from '../../../../hooks/useOutsideClick';
import classNames from 'classnames';
import { schemesStore } from '../../../../store/mobx/schemes.store';
import Icon from '../../../../helpers/components/Icon';
import MenuDivider from '../../SchemeUI/MenuDivider';
import { SchemeModes } from '../../../../consts/scheme.consts';
import { useSchemeEditorContext } from '../../SchemeEditorProvider';

const ProtocolHandler = ({ node }) => {
  const [
    protocolMenuOpened,
    protocolMenuPosition,
    openProtocolMenu,
    closeProtocolMenu,
    protocolMenuRef,
  ] = useContextMenu();

  const { upsertSchemeNode, toggleActivateProtocol } = schemesStore;
  const { schemeMode } = useSchemeEditorContext();

  useOutsideClick(protocolMenuRef, closeProtocolMenu);

  const handleUpdateProtocol = async (protocolId, activate) => {
    if (activate) {
      toggleActivateProtocol(protocolId);
    }
    await upsertSchemeNode({ ...node, id_protocol: protocolId });
  };

  const ProtocolIndicator = () => (
    <div
      className={classNames(styles.protocolIndicator, {
        [styles.active]: protocolMenuOpened,
        [styles.editable]: schemeMode === SchemeModes.edit,
      })}
      onClick={(e) => schemeMode === SchemeModes.edit && openProtocolMenu(e)}
    >
      <div className={styles.indicatorIcon}>
        <Icon
          src={node.protocol?.is_active ? protocolIcon : attentionIcon}
          color={node.protocol?.is_active ? 'var(--color-brand)' : '#c12d2d'}
          width={'24px'}
          height={'24px'}
        />
      </div>
      <span
        className={classNames(styles.indicatorLabel, {
          [styles.inactive]: !node.protocol?.is_active,
        })}
      >
        {node.protocol?.name}
      </span>
      {protocolMenuOpened && <MenuDivider />}
    </div>
  );

  return (
    <div className={styles.resourceItemContainer}>
      {node.protocol && <ProtocolIndicator />}
      {schemeMode === SchemeModes.edit && !node.protocol && (
        <AddResourceButton
          classname={classNames(styles.addButton)}
          title={'Добавить протокол'}
          onClick={openProtocolMenu}
          active={protocolMenuOpened}
        />
      )}
      {protocolMenuOpened && (
        <ProtocolSelectMenu
          ref={protocolMenuRef}
          position={{
            top: protocolMenuPosition.top,
            bottom: protocolMenuPosition.bottom,
            left: '100%',
          }}
          protocol={{ ...node.protocol }}
          onSelect={handleUpdateProtocol}
          onClose={closeProtocolMenu}
        />
      )}
    </div>
  );
};

export default ProtocolHandler;
